module.exports = __webpack_public_path__ + "static/notebook-1ce3e19da536a9ed55b696951c2933c7.svg";